<template>
  <div class="isTxt" v-if="isTxt">
    {{ isTextValue || '-' }}
  </div>
  <template v-else>
    <div>
      <AddressType
        :showCity="showCity"
        :showArea="showArea"
        :disabled="renderConfig.disabled"
        :data="data"
        v-model="addressData"
      />
      <RxkInput
        v-if="data.columnInfo.precisions === 1"
        style="margin-top: 8px"
        type="textarea"
        :maxLength="maxLength"
        :disabled="renderConfig.disabled"
        v-model="addressData.detail"
        @blur="blur"
      />
    </div>
  </template>
</template>
<script lang="ts" setup>
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import AddressType from './addressType.vue'
import { RxkInput } from '@/components/common'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { debounce } from 'lodash-es'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'blur'])

const innerValue = computed({
  get() {
    console.log(props.modelValue, 'props.modelValueprops.modelValue')

    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
const addressData = ref<Recordable>({})
const isTextValue = ref('-')
onMounted(() => {
  dealData()
})

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    nextTick(() => {
      dealData()
    })

    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)

// 失焦验证数据
const isInputBlur = ref(false)
function blur() {
  isInputBlur.value = true
  dealBlur(addressData.value)
}
const dealBlur = debounce(e => {
  const precisions = props.data.columnInfo.precisions

  const checkAddress = (valueObj: any) => {
    if (precisions === 1 && isInputBlur.value) {
      console.log('%c 地址787878value', 'font-size:20px;color:red', valueObj)
      return valueObj.province && valueObj.city && valueObj.area && valueObj.detail
    } else if (precisions === 2) {
      return valueObj.province && valueObj.city && valueObj.area
    } else if (precisions === 3) {
      return valueObj.province && valueObj.city
    } else if (precisions === 4) {
      return valueObj.province
    }
  }
  if (checkAddress(e)) {
    emit('blur', JSON.stringify(e))
  }
}, 500)

function dealData() {
  console.log(innerValue.value, 'innerValue.value ')
  try {
    const defaultData = innerValue.value ? JSON.parse(innerValue.value || '{}') : {}
    addressData.value.province = defaultData.province || ''
    addressData.value.city = defaultData.city || ''
    addressData.value.area = defaultData.area || ''
    addressData.value.pName = defaultData.pName || ''
    addressData.value.cName = defaultData.cName || ''
    addressData.value.aName = defaultData.aName || ''
    addressData.value.detail = defaultData.detail || ''
    addressData.value.full = getTextValue()
    console.log(addressData, 'addressData1233', getTextValue())
    isTextValue.value = getTextValue()
  } catch (e) {
    console.log(e)
  }
}

// 展示到市
const showCity = computed(() => {
  const precisions = props.data.columnInfo.precisions || 0
  return Number(precisions) < 4
})
// 展示到区
const showArea = computed(() => {
  const precisions = props.data.columnInfo.precisions || 0
  return Number(precisions) < 3
})

function getTextValue() {
  const { pName = '', cName = '', aName = '', detail } = addressData.value
  if (props.data.columnInfo.precisions === 1) {
    return pName + cName + aName + detail || '-'
  } else if (props.data.columnInfo.precisions === 2) {
    return pName + cName + aName || '-'
  } else if (props.data.columnInfo.precisions === 3) {
    return pName + cName || '-'
  } else if (props.data.columnInfo.precisions === 4) {
    return pName || '-'
  } else {
    return '-'
  }
}

watch(
  () => addressData.value,
  () => {
    console.log('变了吗', addressData)
    dealBlur(addressData.value)
    innerValue.value = JSON.stringify(addressData.value)
  },
  {
    deep: true
  }
)

watch(
  () => props.isTxt,
  () => {
    dealData()
  }
)
watch(
  () => props.modelValue,
  () => {
    dealData()
  }
)
</script>
